//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('contentCardToggle', {
    template: require('@legacy-components/common/content-card/content-card-toggle.html'),
    bindings: {
      viewMode: '<',
      trackingCategory: '<',
    },
    controllerAs: '$contentToggle',
    controller: [
      '$scope',
      '$rootScope',
      '$timeout',
      'ContentCardViews',
      'TrackingService',
      function(
                $scope,
                $rootScope,
                $timeout,
                ContentCardViews,
                TrackingService,
            ) {
        const self = this;

        $scope.model = {
          ContentCardViews,
          viewMode: self.viewMode || ContentCardViews.META,
        };

        $scope.model.onToggle = function(view) {
          $rootScope.$broadcast('suspendable-pause-updates');
          $rootScope.$broadcast('suspendable-resume-suspended');

          $rootScope.$broadcast('content-card.view', view);

          TrackingService.recordEvent(
                        self.trackingCategory, `${TrackingService.CATEGORY_CONTENT_CARD}:${TrackingService.ACTION_SELECT_TOGGLE}`, view,
                    );

          $timeout(() => {
            $rootScope.$broadcast('suspendable-resume-updates');
            $rootScope.$broadcast('iso-layout');
          }, 0);
        };
      },
    ],
  });
})();
